//Componentes Generales
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NewProductItm from "../newProductItm/NewProductItm";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import Tesseract from "tesseract.js";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SelectList from "../../components/SelectList/SelectList.js";
import DropDownPicker from "../DropDownPicker/DropDownPicker.js";

//Context
import proveedoresContext from "../../context/proveedores/proveedoresContext.js";
import authContext from "../../context/authentication/authContex.js";

//Api
import {
  downloadFile,
  getFile,
  getTDocsByCodForAndCodOriAndNroCta,
  getRemitosFromOCP,
} from "../../api/transactionDocuments.js";
import { verifyLicense } from "../../api/license";
import { getSubcuentasByDimension } from "../../api/subcuenta";

//Util
import {
  formatosFecha,
  getNewFormattedDate,
  generarFechasConNombreMes,
} from "../../utils/formatDate.js";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faSpinner } from "@fortawesome/free-solid-svg-icons";

import Swal from "sweetalert2";

// Estilos
import "./FormReq.css";

// Utils
import {
  getMontoCuartoFormato,
  getMontoEnLetras,
  getMontoPrimerFormato,
  getMontoSegundoFormato,
  getMontoTercerFormato,
  monedas,
} from "../../utils/monedas.js";
import {
  formatCuitGuiones,
  formatCuitGuionPunto,
  formatCuitPuntoGuion,
  formatCuitPuntos,
  getMimeTypeByExtension,
} from "../../utils/funciones.js";

//ENTORNO
import { ENTORNO } from "../../config/config";
import { GUARDAR_TDOCS_SIN_VALIDACION } from "../../utils/permisos.js";

// Constante con estructura del producto.
const estructura_producto = {
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
};

const getEstructuraProducto = () => ({
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
});

function FormReq({
  edicion,
  req,
  files = [],
  itemList,
  productList,
  guardarReq,
  cerrar,
}) {
  const [loading, setLoading] = useState(true);
  const [cliente, setCliente] = useState(ENTORNO);
  const [requeriment, setRequeriment] = useState(req);
  const [subcuentaSelected, setSubcuentaSelected] = useState({
    codDim: "",
    codDimDescrp: "",
    subCue: "",
    subCueDescrp: "",
  });
  const [formattedImporte, setFormattedImporte] = useState("");
  const [formattedCotizacion, setFormattedCotizacion] = useState("");
  const [displayOptions, setDisplayOptions] = useState();
  const [items, setItems] = useState(
    itemList.length === 0
      ? [estructura_producto]
      : itemList.concat([estructura_producto]),
  );
  const [isModifiedOriginalFile, setIsModifiedOriginalFile] = useState(false);
  const [isModifiedFile, setIsModifiedFile] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(files);
  const [selectionColor, setSelectionColor] = useState(false);
  const [controlBotonEnviar, setControlBotonEnviar] = useState(false);
  const [onFocus, setOnFocus] = useState("");
  const [tiposComprobantes, setTiposComprobantes] = useState([]);
  const [isProfileProv, setIsProfileProv] = useState(false);

  const [checkOcApl, setcheckOcApl] = useState(
    (req.ocsApl?.length === 0) && edicion == "Edicion" ? true : false,
  );
  const [ptoVentaComprobante, setPtoVentaComprobante] = useState(
    req.codOri ? req.codOri.split("-")[0] : "",
  );
  const [nroComprobante, setNroComprobante] = useState(
    req.codOri ? req.codOri.split("-")[1] : "",
  );
  const importeRef = useRef(null);
  const cotizacionRef = useRef(null);
  const [opcionesMoneda, setOpciones] = useState(monedas);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [processingPDF, setProcessingPDF] = useState(false);
  const [skipValidation, setSkipValidation] = useState(false);
  const [licencia, setLicencia] = useState({});
  const [text, setText] = useState(null);
  const [subcuentas, setSubcuentas] = useState([]);

  const observadaRef = useRef(false);

  const msgsObservadaRef = useRef({
    cuitReceptor: "",
    cuitEmisor: "",
    nroFactura: "",
    fecha: "",
    importe: "",
  });

  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;
  const aContext = useContext(authContext);
  const {
    usuario,
    globalSettings,
    obtenerGlobalSettings,
    updateGlobalSettings,
  } = aContext;

  const isAdminOrControl = usuario?.userType?.some((item) =>
    GUARDAR_TDOCS_SIN_VALIDACION.includes(item.typeName),
  );

  const navigate = useNavigate();

  useEffect(() => {
    let newRequeriment = {
      ...requeriment,
      quantity: 1,
      ocsApl: req.ocsApl?.length > 0
        ? { nroFor: req.ocsApl.map((oc) => ({ label: String(oc.nroFor), value: String(oc.nroFor) })) }
        : { nroFor: [] },
    };
    const fn = async () => {
      try {
        await obtenerGlobalSettings();
        if (!usuario.nroCta || usuario.nroCta == "") {
          await actualizarProveedores();
        } else {
          newRequeriment.nroCta = usuario.nroCta;
          newRequeriment.nroCtaDescrp = usuario.fullName;
          newRequeriment.cuitProv = usuario.userName.replaceAll("-", "");
          setIsProfileProv(true);
        }
        const respLicencia = await verifyLicense();
        if (respLicencia.data.data.nombre.toLowerCase().includes("solimeno")) {
          setTiposComprobantes([
            { tipo: "FA", descripcion: "Factura" },
            { tipo: "NCA", descripcion: "Nota de Crédito" },
            { tipo: "NDA", descripcion: "Nota de Débito" },
          ]);
        } else {
          setTiposComprobantes([
            { tipo: "FAC", descripcion: "Factura" },
            { tipo: "NC", descripcion: "Nota de Crédito" },
            { tipo: "ND", descripcion: "Nota de Débito" },
          ]);
        }
        setLicencia(respLicencia.data.data);
      } catch (error) {
        console.error("Error en inicialización FormReq:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    };
    fn();
    //handlerIniciarlizarFiltros();
    let newItem = [
      {
        artCod: "1",
        codRed: "1",
        descrp: "Producto Genérico",
        quantity: "1",
        textAdic: "",
        tipPro: "T1",
      },
      { ...getEstructuraProducto() },
    ];
    setRequeriment(newRequeriment);
    setItems(newItem);
  }, []);

  useEffect(() => {
    try {
      const fn = async () => {
        if (edicion) {
          const formatted = formatWithCommas(requeriment.importe);
          setFormattedImporte(formatted);
          if (requeriment.cotizacion) {
            const formatted = formatWithCommas(requeriment.cotizacion);
            setFormattedCotizacion(formatted);
          }
        }

        if (
          globalSettings.requiredSubcuenta == true &&
          globalSettings.codDim !== subcuentaSelected.codDim
        ) {
          const respSubcuentas = await getSubcuentasByDimension(
            globalSettings.codDim,
          );
          setSubcuentas(respSubcuentas.data.data);
          setSubcuentaSelected({
            codDim: globalSettings.codDim,
            codDimDescrp: globalSettings.codDimDescrp,
            subCue: "",
            subCueDescrp: "",
          });
        } else if (
          globalSettings.requiredSubcuenta == false &&
          subcuentaSelected.codDim
        ) {
          setSubcuentaSelected({
            codDim: "",
            codDimDescrp: "",
            subCue: "",
            subCueDescrp: "",
          });
        }
      };
      fn();
    } catch (error) {
      console.error("Error en actualización FormReq:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [globalSettings]);

  const handleChangeCodOri = (data) => {
    setRequeriment({ ...requeriment, codOri: data });
  };

  const handleChangePtoVenta = (e) => {
    const maxLen = ENTORNO.toLowerCase().includes("solimeno") ? 4 : 5;
    const value = e.target.value.replace(/\D/g, "").slice(0, maxLen);
    setPtoVentaComprobante(value);
    setRequeriment({
      ...requeriment,
      codOri:
        value && nroComprobante
          ? `${value}-${nroComprobante}`
          : value || nroComprobante || "",
    });
  };

  const handleChangeNroComprobante = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 8);
    setNroComprobante(value);
    setRequeriment({
      ...requeriment,
      codOri:
        ptoVentaComprobante && value
          ? `${ptoVentaComprobante}-${value}`
          : ptoVentaComprobante || value || "",
    });
  };

  const handleBlurPtoVenta = () => {
    if (ptoVentaComprobante && ptoVentaComprobante.length > 0) {
      const padded = ptoVentaComprobante.padStart(
        ENTORNO.toLowerCase().includes("solimeno") ? 4 : 5,
        "0",
      );
      setPtoVentaComprobante(padded);
      setRequeriment({
        ...requeriment,
        codOri:
          padded && nroComprobante
            ? `${padded}-${nroComprobante}`
            : padded || nroComprobante || "",
      });
    }
  };

  const handleBlurNroComprobante = () => {
    if (nroComprobante && nroComprobante.length > 0) {
      const padded = nroComprobante.padStart(8, "0");
      setNroComprobante(padded);
      setRequeriment({
        ...requeriment,
        codOri:
          ptoVentaComprobante && padded
            ? `${ptoVentaComprobante}-${padded}`
            : ptoVentaComprobante || padded || "",
      });
    }
  };

  const handleChangeProveedor = async (value) => {
    const proveedorSeleccionado = proveedores.find(
      (p) =>
        `${p.nroCta}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (proveedorSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        nroCta: proveedorSeleccionado.nroCta,
        nroCtaDescrp: proveedorSeleccionado.nombre,
        cuitProv: proveedorSeleccionado.cuit,
      });
    }
  };

  const handleChangeSubcuenta = async (value) => {
    const subcuentaSeleccionada = subcuentas.find(
      (s) =>
        `${s.subCue}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (subcuentaSeleccionada !== undefined) {
      setSubcuentaSelected({
        ...subcuentaSelected,
        subCue: subcuentaSeleccionada.subCue,
        subCueDescrp: subcuentaSeleccionada.subCueDescrp,
      });
    }
  };

  const handleChangeTipoComprobante = async (value) => {
    const tipoComprobanteSeleccionado = tiposComprobantes.find(
      (tC) =>
        `${tC.tipo}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (tipoComprobanteSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocCodFor: tipoComprobanteSeleccionado.tipo,
        tDocCodForDescrp: tipoComprobanteSeleccionado.descripcion,
      });
    }
  };

  const sanitize = (value) => {
    // quitar caracteres que no sean dígitos o punto decimal
    let v = value.replace(/[^0-9.]/g, "");

    // permitir solo un punto
    const parts = v.split(".");
    if (parts.length > 2) {
      v = parts.shift() + "." + parts.join("");
    }

    return v;
  };

  const formatWithCommas = (value) => {
    if (!value) return "";

    const num = Number(value);
    if (isNaN(num)) return "";

    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChangeImporte = (e) => {
    const input = sanitize(e.target.value);

    setRequeriment({
      ...requeriment,
      importe: input, // guardado interno sin formatear
    });

    setFormattedImporte(input); // lo que ve mientras escribe
  };

  const handleFocusImporte = () => {
    setFormattedImporte(requeriment.importe || "");
  };

  const handleBlurImporte = () => {
    const raw = requeriment.importe || "";
    const formatted = formatWithCommas(raw);

    setFormattedImporte(formatted);
  };

  const handleChangeCotizacion = (e) => {
    const input = sanitize(e.target.value);

    setRequeriment({
      ...requeriment,
      cotizacion: input, // guardado interno sin formatear
    });

    setFormattedCotizacion(input); // lo que ve mientras escribe
  };

  const handleFocusCotizacion = () => {
    setFormattedCotizacion(requeriment.cotizacion || "");
  };

  const handleBlurCotizacion = () => {
    const raw = requeriment.cotizacion || "";
    const formatted = formatWithCommas(raw);

    setFormattedCotizacion(formatted);
  };

  const handleChangeMoneda = async (value) => {
    const monedaSeleccionada = opcionesMoneda.find(
      (o) =>
        `${o}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (monedaSeleccionada !== undefined) {
      if (monedaSeleccionada == "PESOS") {
        setRequeriment({
          ...requeriment,
          moneda: monedaSeleccionada,
          cotizacion: "",
        });
      } else {
        setRequeriment({
          ...requeriment,
          moneda: monedaSeleccionada,
        });
      }
    }
  };

  const handleChangeDateOfIssue = (data) => {
    const fecha = new Date(data.concat("T00:00:00.000"));
    setRequeriment({ ...requeriment, dateOfIssue: fecha });
  };

  const handleChangObservation = (data) => {
    setRequeriment({ ...requeriment, observ: data });
  };

  const handleagregaItem = (data) => {
    //Se le asigna un id random al nuevo producto añadido. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const tempData = { ...data, usr_id: (Math.random() * 100).toString() };
    //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const nuevaEstructura = {
      ...estructura_producto,
      usr_id: (Math.random() * 100).toString(),
    };
    //Logica para determinar donde inserta el item vacio.
    const temp_List = items.length === 1 ? [nuevaEstructura] : items;
    const newLista =
      temp_List.length === 1
        ? [tempData, ...temp_List]
        : [
            ...temp_List.filter((d) => d.artCod !== ""),
            tempData,
            nuevaEstructura,
          ];

    setItems(newLista);
    console.log(newLista);
  };

  const handleDeleteConcept = (item, i) => {
    if (i !== items.length - 1) {
      setItems(
        items.filter((data, index) => {
          if (index !== i) {
            return data;
          }
        }),
      );
    }
  };

  const handleChangeItm = (data, i) => {
    const newLista = items.map((it, index) => {
      return it.codRed === data.codRed &&
        it.artCod === data.artCod &&
        index === i
        ? data
        : it;
    });
    setItems(newLista);
  };

  const handleFileInputChange = (e) => {
    if (e.target.files.length === 0) return;

    setIsModifiedFile(true);

    const filesArray = Array.from(e.target.files);
    const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB en bytes

    for (const file of filesArray) {
      const allowedTypes = ["application/pdf", "image/jpeg"];
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: "Sólo se permiten archivos PDF o JPG/JPEG",
          icon: "error",
        });
        e.target.value = null;
        return;
      }

      const allowedExtensions = ["pdf", "jpg", "jpeg"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: "Extensión no permitida",
          icon: "error",
        });
        e.target.value = null;
        setProcessingPDF(false);
        return;
      }

      // Validación de tamaño (50 MB máximo por archivo)
      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          title: "Archivo demasiado grande!",
          text: `El archivo "${
            file.name
          }" supera el límite de 50 MB. Tamaño actual: ${(
            file.size /
            (1024 * 1024)
          ).toFixed(2)} MB`,
          icon: "error",
        });
        e.target.value = null;
        setProcessingPDF(false);
        return;
      }
    }

    setSelectedFiles([...selectedFiles, ...e.target.files]);
    if (edicion == "Edicion" && isModifiedOriginalFile == false) {
      setIsModifiedOriginalFile(true);
    }
    e.target.value = null;
    setProcessingPDF(false);
  };

  /**
   * Extrae texto nativo del PDF (sin OCR) - más preciso para PDFs con texto seleccionable
   * Preserva la estructura del documento agrupando elementos por línea según su posición Y
   */
  const extractTextFromPdf = async (file) => {
    try {
      GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.mjs";
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();

        // Agrupar items por línea usando su posición Y (transform[5])
        const lineMap = new Map();
        const tolerance = 5; // Tolerancia para considerar items en la misma línea

        for (const item of textContent.items) {
          if (!item.str || item.str.trim() === "") continue;

          const y = Math.round(item.transform[5] / tolerance) * tolerance;
          const x = item.transform[4];

          if (!lineMap.has(y)) {
            lineMap.set(y, []);
          }
          lineMap.get(y).push({ x, text: item.str });
        }

        // Ordenar líneas por Y (de arriba a abajo) y elementos por X (de izquierda a derecha)
        const sortedLines = Array.from(lineMap.entries())
          .sort((a, b) => b[0] - a[0]) // Y descendente (arriba primero)
          .map(([, items]) => {
            return items
              .sort((a, b) => a.x - b.x) // X ascendente (izquierda primero)
              .map((item) => item.text)
              .join(" ");
          });

        const pageText = sortedLines.join("\n");
        fullText += `\n--- PAGE ${i} ---\n${pageText}`;
      }

      return fullText.trim();
    } catch (error) {
      console.log("Error en extractTextFromPdf: ", error);
      return "";
    }
  };

  /**
   * Corrige caracteres comúnmente confundidos por el OCR
   * Especialmente útil para fechas con nombres de meses
   */
  const postProcessOcrText = (text) => {
    if (!text) return text;

    // Mapeo de caracteres comúnmente confundidos
    const corrections = {
      "£": "E",
      "€": "E",
      "∈": "E",
      "|": "I",
      "!": "I",
      $: "S",
      "§": "S",
    };

    // Primero aplicar correcciones generales de caracteres especiales
    let correctedText = text;
    for (const [wrong, correct] of Object.entries(corrections)) {
      correctedText = correctedText.split(wrong).join(correct);
    }

    // Patrones específicos para meses mal leídos (case insensitive)
    const monthCorrections = [
      // Enero
      { pattern: /\b3N[3E]RO\b/gi, replacement: "ENERO" },
      { pattern: /\b[3E]N[3E]\b/gi, replacement: "ENE" },
      // Febrero
      { pattern: /F[3E]BR[3E]RO/gi, replacement: "FEBRERO" },
      { pattern: /F[3E]B/gi, replacement: "FEB" },
      // Marzo
      { pattern: /MARZ[0O]/gi, replacement: "MARZO" },
      // Abril
      { pattern: /ABR[1I]L/gi, replacement: "ABRIL" },
      // Mayo (generalmente OK)
      // Junio
      { pattern: /JUN[1I][0O]/gi, replacement: "JUNIO" },
      // Julio
      { pattern: /JUL[1I][0O]/gi, replacement: "JULIO" },
      // Agosto
      { pattern: /AG[0O]ST[0O]/gi, replacement: "AGOSTO" },
      { pattern: /AG[0O]/gi, replacement: "AGO" },
      // Septiembre
      { pattern: /S[3E]PT[1I][3E]MBR[3E]/gi, replacement: "SEPTIEMBRE" },
      { pattern: /S[3E]P/gi, replacement: "SEP" },
      // Octubre
      { pattern: /[0O]CTUBR[3E]/gi, replacement: "OCTUBRE" },
      { pattern: /[0O]CT/gi, replacement: "OCT" },
      // Noviembre
      { pattern: /N[0O]V[1I][3E]MBR[3E]/gi, replacement: "NOVIEMBRE" },
      { pattern: /N[0O]V/gi, replacement: "NOV" },
      // Diciembre
      { pattern: /D[1I]C[1I][3E]MBR[3E]/gi, replacement: "DICIEMBRE" },
      { pattern: /D[1I]C/gi, replacement: "DIC" },
    ];

    for (const { pattern, replacement } of monthCorrections) {
      correctedText = correctedText.replace(pattern, replacement);
    }

    return correctedText;
  };

  /**
   * Aplica preprocesamiento a la imagen para mejorar la precisión del OCR
   * - Aumenta el contraste
   * - Convierte a escala de grises
   * - Aplica binarización (threshold)
   * - Aplica sharpening (nitidez)
   */
  const preprocessImageForOcr = (canvas, useBinarization = true) => {
    const context = canvas.getContext("2d");
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    // Paso 1: Aumentar contraste
    const contrastFactor = 1.7;
    for (let i = 0; i < data.length; i += 4) {
      data[i] = Math.min(
        255,
        Math.max(0, (data[i] - 128) * contrastFactor + 128),
      );
      data[i + 1] = Math.min(
        255,
        Math.max(0, (data[i + 1] - 128) * contrastFactor + 128),
      );
      data[i + 2] = Math.min(
        255,
        Math.max(0, (data[i + 2] - 128) * contrastFactor + 128),
      );
    }

    // Paso 2: Convertir a escala de grises
    for (let i = 0; i < data.length; i += 4) {
      const gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;

      if (useBinarization) {
        // Umbral más alto para eliminar bordes de celdas (grises ~150-180) sin perder texto negro
        const threshold = 185;
        const binaryValue = gray > threshold ? 255 : 0;
        data[i] = binaryValue;
        data[i + 1] = binaryValue;
        data[i + 2] = binaryValue;
      } else {
        // Solo escala de grises sin binarización (mejor para texto con diferentes tonos)
        data[i] = gray;
        data[i + 1] = gray;
        data[i + 2] = gray;
      }
    }

    context.putImageData(imageData, 0, 0);
    return canvas;
  };

  const convertPdfToImages = async (file) => {
    try {
      //Worker es un archivo javascript separado que corre en otro hilo, separado de nuestro navegador. Trabaja procesando y parseando el  archivo PDF.
      //Este link y otro pueden obtenerse desde https://cdnjs.com/libraries/pdf.js/4.10.38, asegurarse de que el endpoint contenga worker.
      GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.mjs";
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      const images = [];

      // Escala aumentada para mejor resolución y precisión del OCR
      const scale = 4;

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale });

        // Crear DOS versiones de la imagen para mejor cobertura de OCR

        // Versión 1: Con binarización (mejor para texto negro sobre blanco)
        const canvas1 = document.createElement("canvas");
        const context1 = canvas1.getContext("2d");
        canvas1.width = viewport.width;
        canvas1.height = viewport.height;
        context1.fillStyle = "white";
        context1.fillRect(0, 0, canvas1.width, canvas1.height);
        await page.render({ canvasContext: context1, viewport }).promise;
        preprocessImageForOcr(canvas1, true); // Con binarización

        // Versión 2: Sin binarización (mejor para texto gris o con diferentes tonos)
        const canvas2 = document.createElement("canvas");
        const context2 = canvas2.getContext("2d");
        canvas2.width = viewport.width;
        canvas2.height = viewport.height;
        context2.fillStyle = "white";
        context2.fillRect(0, 0, canvas2.width, canvas2.height);
        await page.render({ canvasContext: context2, viewport }).promise;
        preprocessImageForOcr(canvas2, false); // Sin binarización, solo escala de grises

        // Agregar ambas versiones para que el OCR las procese
        images.push({
          binarized: canvas1.toDataURL("image/png", 1.0),
          grayscale: canvas2.toDataURL("image/png", 1.0),
          pageNumber: i,
        });
      }
      return images;
    } catch (error) {
      console.log("Error en convertPdfToImages: ");
      console.log(error);
    }
  };

  const getTextFromImage = async (file) => {
    const regexNroFactura = /\d{4,5}\s*[-–—]\s*\d{8,9}/;
    const tesseractBase = {
      langPath: "https://tessdata.projectnaptha.com/4.0.0_best",
      tessedit_ocr_engine_mode: "1", // OEM 1: LSTM puro, óptimo para modelos _best
      preserve_interword_spaces: "1",
    };

    // PSM 3: Segmentación automática (mejor para facturas con múltiples bloques)
    let data = await Tesseract.recognize(file, "spa+eng", {
      ...tesseractBase,
      tessedit_pageseg_mode: "3",
    });
    let rawText = data.data.text || "";

    // PSM 6: Bloque uniforme de texto
    if (!regexNroFactura.test(rawText)) {
      console.log("  └─ Reintentando OCR con PSM 6...");
      const data2 = await Tesseract.recognize(file, "spa+eng", {
        ...tesseractBase,
        tessedit_pageseg_mode: "6",
      });
      const rawText2 = data2.data.text || "";
      if (regexNroFactura.test(rawText2) || rawText2.length > rawText.length) {
        rawText = rawText2;
      }
    }

    // PSM 11: Sparse text — encuentra texto sin analizar layout (resuelve celdas AFIP)
    if (!regexNroFactura.test(rawText)) {
      console.log("  └─ Reintentando OCR con PSM 11 (sparse)...");
      const data3 = await Tesseract.recognize(file, "spa+eng", {
        ...tesseractBase,
        tessedit_pageseg_mode: "11",
      });
      const rawText3 = data3.data.text || "";
      if (regexNroFactura.test(rawText3) || rawText3.length > rawText.length) {
        rawText = rawText3;
      }
    }

    // Aplicar corrección de caracteres comúnmente confundidos
    return postProcessOcrText(rawText);
  };

  const validateOCApl = () => {
    if (checkOcApl) {
      return ""; // Si marcó "No tengo Órdenes de Compra", no validar
    }
    const nroForArr = requeriment.ocsApl?.nroFor;
    if (nroForArr?.length === 0)
      return 'Complete el número de Órdenes de Compra o tilde la opción "No tengo Órdenes de Compra"';

    const isOnlyNumbersOrHyphen = (str) => /^[0-9-]+$/.test(str.toString().trim());

    for (const option of nroForArr) {
      if (!isOnlyNumbersOrHyphen(option.value))
        return "Ingrese sólo números en el campo Órdenes de Compra";
    }

    return "";
  };

  const validate = async (newLista) => {
    try {
      let msg = "";
      if (!requeriment.nroCta) {
        return "Debe seleccionar un proveedor";
      }
      if (!requeriment.tDocCodFor)
        return "Debe seleccionar un tipo de comprobante";
      if (requeriment.codOri == "") return "Ingrese el número de comprobante";

      // Validación de fecha
      /* if (
        cliente.toLowerCase().includes("moviport") &&
        requeriment.dateOfIssue
      ) { */
      if (requeriment.dateOfIssue) {
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        const fechaEmision = new Date(requeriment.dateOfIssue);
        fechaEmision.setHours(0, 0, 0, 0);

        // Solo validar si la fecha es ANTERIOR a hoy
        if (fechaEmision < fechaActual && !edicion) {
          const diffTime = fechaActual - fechaEmision;
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

          if (
            diffDays > 5 &&
            (!usuario.permissionRegTdoc ||
              usuario.permissionRegTdoc?.allowOldDateOfIssue === false)
          ) {
            return "No está permitido cargar facturas con más de 5 días de antigüedad";
          }
        }
      }

      if (requeriment.importe == "")
        return "Complete el importe del comprobante";
      if (!requeriment.moneda || requeriment.moneda == "") {
        return "Debe seleccionar el tipo de moneda";
      }
      if (
        requeriment.moneda &&
        requeriment.moneda !== "PESOS" &&
        (!requeriment.cotizacion || requeriment.cotizacion <= 0)
      ) {
        return "La cotización debe ser mayor a 0";
      }
      if (
        globalSettings.codDim &&
        globalSettings.codDim !== "" &&
        (!subcuentaSelected.subCue || subcuentaSelected.subCue === "")
      ) {
        return "Debe seleccionar una subcuenta";
      }
      if (!checkOcApl) {
        const msgOCApl = validateOCApl();
        if (msgOCApl) return msgOCApl;
      }
      if (requeriment.quantity == 0)
        return "Debe ingresar al menos un producto/servicio";
      let control = 0;
      for (const item of newLista) {
        if (item.quantity === 0) {
          control = 1;
        }
      }
      if (control === 1) {
        return "Existe un item sin cantidad asignada";
      }
      if (selectedFiles.length < 1) return "Debe adjuntar un archivo";
      if (edicion !== "Edicion") {
        const respTDoc = await getTDocsByCodForAndCodOriAndNroCta(
          requeriment.tDocCodFor,
          requeriment.codOri,
          requeriment.nroCta,
        );
        let comprobante = null;
        if (respTDoc.data.data) {
          respTDoc.data.data.map((tDoc) => {
            if (tDoc.state !== "RECHAZADO") {
              comprobante = tDoc.codOri;
            }
          });
        }

        if (comprobante)
          return `El número ${comprobante} ya existe para el proveedor y tipo de comprobante seleccionados`;
      }
      return msg;
    } catch (error) {
      console.error("Error durante el proceso de validación:", error);
      throw new Error(
        "Ocurrió un error inesperado durante la validación de los datos. Intente nuevamente.",
        { cause: error },
      );
    }
  };

  const procesarArchivo = async (includeOcr = true) => {
    setIsModifiedFile(false);

    try {
      console.log("🚀 Iniciando procesamiento de archivo...");
      let file;

      if (edicion === "Edicion" && isModifiedOriginalFile === false) {
        console.log("📥 Descargando archivo desde servidor...");
        const extensionMimeType = getMimeTypeByExtension(selectedFiles[0].name);
        const response = await downloadFile(selectedFiles[0].name);
        const blob = new Blob([response.data], { type: extensionMimeType });
        file = new File([blob], selectedFiles[0].name, {
          type: extensionMimeType,
        });

        const objectUrl = URL.createObjectURL(file);
        URL.revokeObjectURL(objectUrl);
      } else {
        file = selectedFiles[0];
      }

      console.log(
        `📄 Archivo: ${file.name} (${file.type}, ${(file.size / 1024).toFixed(2)} KB)`,
      );

      let fullText = "";

      if (file.type === "application/pdf") {
        console.log("📄 Procesando PDF...");

        try {
          // ESTRATEGIA COMBINADA: Extraer texto nativo + OCR para máxima cobertura

          // 1. Intentar extraer texto nativo del PDF (funciona bien con PDFs digitales de AFIP)
          console.log("  └─ Extrayendo texto nativo del PDF...");
          let nativeText = "";
          try {
            nativeText = await extractTextFromPdf(file);
            console.log(
              `     ✓ Texto nativo: ${nativeText?.length || 0} caracteres`,
            );
          } catch (nativeError) {
            console.log(
              "     ⚠ No se pudo extraer texto nativo:",
              nativeError.message,
            );
          }

          if (!includeOcr) {
            // Modo rápido: solo texto nativo, sin OCR
            console.log("     ✓ Modo rápido: usando solo texto nativo");
            fullText = nativeText || "";
          } else {
            // 2. Hacer OCR para capturar texto que pueda estar como imagen
            console.log("  └─ Procesando con OCR...");
            const ocrText = await performOcrOnPdf(file);
            console.log(`     ✓ OCR: ${ocrText?.length || 0} caracteres`);

            // 3. Combinar resultados
            const tieneFacturaNativo = /\d{4,5}\s*[-–—]\s*\d{6,8}/.test(nativeText);
            const tieneFacturaOcr = /\d{4,5}\s*[-–—]\s*\d{6,8}/.test(ocrText);

            if (tieneFacturaNativo && !tieneFacturaOcr) {
              console.log("     ℹ Combinando texto nativo (tiene nro factura) con OCR");
              fullText = `${nativeText}\n\n--- TEXTO OCR ---\n${ocrText}`;
            } else if (nativeText && nativeText.length > ocrText.length * 0.5) {
              console.log("     ℹ Combinando texto nativo con OCR");
              fullText = `${nativeText}\n\n--- TEXTO OCR ---\n${ocrText}`;
            } else {
              fullText = ocrText;
            }
          }
        } catch (error) {
          console.error("  └─ ❌ Error procesando PDF:", error);
          throw error;
        }
      } else if (file.type.startsWith("image/")) {
        console.log("🖼️ Procesando imagen con OCR...");
        fullText = await getTextFromImage(file);
        console.log(`✓ OCR completado: ${fullText?.length || 0} caracteres`);
      } else {
        throw new Error(`Tipo de archivo no soportado: ${file.type}`);
      }

      // Validación final
      if (!fullText || fullText.trim().length === 0) {
        console.error("❌ No se pudo extraer texto del archivo");
        throw new Error("No se pudo extraer texto del archivo");
      }

      console.log(`✅ Procesamiento completado: ${fullText.length} caracteres`);
      console.log(`📝 Vista previa:\n${fullText}`);

      setText(fullText);
      return fullText;
    } catch (error) {
      setProcessingPDF(false);
      console.error("❌ Error procesando el archivo:", error);
      throw new Error(`Error procesando el archivo: ${error.message}`, {
        cause: error,
      });
    }
  };

  /**
   * Extrae un crop del área superior-derecha de una imagen (donde está el N° de comprobante AFIP)
   * y corre OCR sobre ese crop con mayor zoom efectivo.
   */
  const getOcrFromHeaderCrop = async (imageDataUrl) => {
    try {
      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = imageDataUrl;
      });

      // El encabezado AFIP con el N° de comprobante siempre está en el cuadrante top-right:
      // X: 40% → 100% del ancho   |   Y: 0% → 22% de la altura
      const cropX = Math.floor(img.width * 0.40);
      const cropY = 0;
      const cropW = img.width - cropX;
      const cropH = Math.floor(img.height * 0.22);

      // Escalar el crop 2x para aumentar la resolución efectiva sobre esa zona
      const scale = 2;
      const cropCanvas = document.createElement("canvas");
      cropCanvas.width = cropW * scale;
      cropCanvas.height = cropH * scale;
      const ctx = cropCanvas.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(
        img,
        cropX, cropY, cropW, cropH,
        0, 0, cropW * scale, cropH * scale,
      );

      const data = await Tesseract.recognize(
        cropCanvas.toDataURL("image/png"),
        "spa+eng",
        {
          langPath: "https://tessdata.projectnaptha.com/4.0.0_best",
          tessedit_ocr_engine_mode: "1",
          tessedit_pageseg_mode: "6", // Bloque uniforme: mejor para la franja del encabezado
          preserve_interword_spaces: "1",
        },
      );
      return data.data.text || "";
    } catch {
      return "";
    }
  };

  const performOcrOnPdf = async (file) => {
    const images = await convertPdfToImages(file);
    let ocrText = "";

    console.log(`  └─ Convirtiendo a imágenes: ${images.length} página(s)`);

    // Regex para detectar número de factura AFIP
    const regexFactura = /\d{4,5}\s*[-–—]\s*\d{6,8}/;
    // Regex estricta: 8-9 dígitos en el número (excluye teléfonos de 7 dígitos)
    const regexFacturaEstricta = /\d{4,5}\s*[-–—]\s*\d{8,9}/;

    for (let i = 0; i < images.length; i++) {
      const imageData = images[i];
      console.log(
        `  └─ OCR página ${imageData.pageNumber}/${images.length}...`,
      );

      // Procesar versión binarizada
      console.log(`     └─ Procesando imagen binarizada...`);
      const textBinarized = await getTextFromImage(imageData.binarized);

      // Procesar versión en escala de grises (sin binarización)
      console.log(`     └─ Procesando imagen en escala de grises...`);
      const textGrayscale = await getTextFromImage(imageData.grayscale);

      // Determinar cuál texto usar o combinar
      let pageText = "";
      const tieneFacturaBinarized = regexFactura.test(textBinarized);
      const tieneFacturaGrayscale = regexFactura.test(textGrayscale);

      if (tieneFacturaGrayscale && !tieneFacturaBinarized) {
        console.log(
          `     ℹ Usando texto de escala de grises (detectó nro factura)`,
        );
        pageText = textGrayscale;
      } else if (tieneFacturaBinarized && !tieneFacturaGrayscale) {
        console.log(`     ℹ Usando texto binarizado (detectó nro factura)`);
        pageText = textBinarized;
      } else if (textGrayscale.length > textBinarized.length) {
        pageText = textGrayscale;
      } else {
        pageText = textBinarized;
      }

      // Si aún no tiene número de factura, combinar ambos textos
      if (!regexFactura.test(pageText) && (textBinarized || textGrayscale)) {
        pageText = `${textBinarized}\n${textGrayscale}`;
      }

      // Si ningún modo encontró un número de comprobante AFIP válido (8-9 dígitos),
      // hacer OCR sobre el crop del encabezado. Usa regex estricta para evitar falsos
      // positivos con teléfonos (ej: 0336-4451779 tiene solo 7 dígitos tras el guión).
      if (!regexFacturaEstricta.test(pageText)) {
        console.log(`     └─ OCR sobre crop del encabezado AFIP...`);
        const headerText = await getOcrFromHeaderCrop(imageData.grayscale);
        if (headerText) {
          console.log(`        ✓ Encabezado: ${headerText.trim().replace(/\n/g, " ")}`);
          // Anteponer el texto del encabezado para que la validación lo encuentre en las primeras líneas
          pageText = `${headerText}\n${pageText}`;
        }
      }

      if (pageText && pageText.trim().length > 0) {
        ocrText += `\n--- PÁGINA ${imageData.pageNumber} ---\n${pageText}`;
        console.log(`     ✓ ${pageText.length} caracteres extraídos`);
      } else {
        console.log(`     ⚠ Página sin texto legible`);
        ocrText += `\n--- PÁGINA ${imageData.pageNumber} ---\n[Sin texto legible]`;
      }
    }

    return ocrText;
  };

  const validateValoresArchivo = async (
    {
      flagImporteChecked = false,
      flagCuitEmisorChecked = false,
      flagFechaChecked = false,
      flagCuitReceptorChecked = false,
      flagNroFacturaChecked = false,
    },
    text = {},
  ) => {
    try {
      let flagCuitReceptor;
      let flagImporte;
      let flagCuitEmisor;
      let flagNroFactura;
      let flagFecha;
      const textNormalized = text.replace(/\s+/g, "");
      let lines = text.split("\n");

      if (licencia.cuit) {
        // Formatear CUIT con guiones: XX-XXXXXXXX-X
        const cuitReceptorFormateadoGuiones = formatCuitGuiones(licencia.cuit);
        // Formatear CUIT con guiones: XX.XXXXXXXX.X
        const cuitReceptorFormateadoPuntos = formatCuitPuntos(licencia.cuit);
        // Formatear CUIT con guiones: XX-XXXXXXXX.X
        const cuitReceptorFormateadoGuionPunto = formatCuitGuionPunto(
          licencia.cuit,
        );
        // Formatear CUIT con guiones: XX.XXXXXXXX-X
        const cuitReceptorFormateadoPuntoGuion = formatCuitPuntoGuion(
          licencia.cuit,
        );

        if (
          text.includes(licencia.cuit) ||
          text.includes(cuitReceptorFormateadoGuiones) ||
          text.includes(cuitReceptorFormateadoPuntos) ||
          text.includes(cuitReceptorFormateadoGuionPunto) ||
          text.includes(cuitReceptorFormateadoPuntoGuion)
        ) {
          flagCuitReceptor = true;
        }
      }

      if (requeriment.cuitProv) {
        // Formatear CUIT con guiones: XX-XXXXXXXX-X
        const cuitEmisorFormateadoGuiones = formatCuitGuiones(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX.XXXXXXXX.X
        const cuitEmisorFormateadoPuntos = formatCuitPuntos(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX-XXXXXXXX.X
        const cuitEmisorFormateadoGuionPunto = formatCuitGuionPunto(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX.XXXXXXXX-X
        const cuitEmisorFormateadoPuntoGuion = formatCuitPuntoGuion(
          requeriment.cuitProv,
        );
        if (
          text.includes(requeriment.cuitProv) ||
          text.includes(cuitEmisorFormateadoGuiones) ||
          text.includes(cuitEmisorFormateadoPuntos) ||
          text.includes(cuitEmisorFormateadoGuionPunto) ||
          text.includes(cuitEmisorFormateadoPuntoGuion)
        ) {
          flagCuitEmisor = true;
        }
      }

      if (lines.length > 0 && requeriment.codOri) {
        const ptoVenta = requeriment.codOri?.split("-")[0];
        const nroFactura = requeriment.codOri?.split("-")[1];

        // Normalizar ptoVenta y nroFactura: eliminar ceros a la izquierda
        const ptoVentaNormalizado = ptoVenta?.replace(/^0+/, "");
        const nroFacturaNormalizado = nroFactura?.replace(/^0+/, "");

        let lineaNroFactura = null;
        for (const line of lines) {
          // Primero verificar si la línea contiene el nroFactura (original o normalizado)
          const contieneNroFactura =
            line.includes(nroFactura) ||
            (nroFacturaNormalizado && line.includes(nroFacturaNormalizado));

          if (contieneNroFactura) {
            // Verificar si también contiene el ptoVenta (en cualquier formato)
            const contienePtoVenta =
              line.includes(ptoVenta) ||
              (ptoVentaNormalizado && line.includes(ptoVentaNormalizado));

            if (contienePtoVenta) {
              lineaNroFactura = line;
              break;
            }
          }
        }
        flagNroFactura = !!lineaNroFactura;
      }

      if (requeriment.dateOfIssue) {
        // Buscar con formatos numéricos (DD/MM/YYYY, etc.)
        const fechaEncontradaNumerica = formatosFecha.some((format) =>
          textNormalized.includes(
            moment(requeriment.dateOfIssue).format(format),
          ),
        );

        if (fechaEncontradaNumerica) {
          flagFecha = true;
        } else {
          // Buscar con nombres de meses (Ene, Enero, etc.)
          const fechasConNombreMes = generarFechasConNombreMes(
            requeriment.dateOfIssue,
          );
          const fechaEncontradaConMes = fechasConNombreMes.some(
            (fechaVariante) =>
              textNormalized
                .toLowerCase()
                .includes(fechaVariante.toLowerCase()),
          );

          if (fechaEncontradaConMes) {
            flagFecha = true;
          }
        }
      }

      if (requeriment.importe) {
        const importe = parseFloat(requeriment.importe); // Convertir a número

        if (!isNaN(importe)) {
          // 1. PrimerFormato: 1,000.01 → inglés (US)
          const primerFormatoImporte = getMontoPrimerFormato(importe);

          // 2. SegundoFormato: 1.000,01 → español (Argentina o Europa)
          const segundoFormatoImporte = getMontoSegundoFormato(importe);

          // 3. TercerFormato: 1000.01 → sin separadores, con punto decimal
          const tercerFormatoImporte = getMontoTercerFormato(importe);

          // 4. CuartoFormato: 1000,01 → sin separadores, con coma decimal
          const cuartoFormatoImporte = getMontoCuartoFormato(importe);

          if (
            text.includes(primerFormatoImporte) ||
            text.includes(segundoFormatoImporte) ||
            text.includes(tercerFormatoImporte) ||
            text.includes(cuartoFormatoImporte)
          ) {
            flagImporte = true;
          } else {
            // 5. Si no se encontró en formatos numéricos, buscar en letras
            const importeEnLetras = getMontoEnLetras(importe);
            const palabrasImporte = importeEnLetras.toLowerCase().split(/\s+/);
            const textLower = text.toLowerCase();

            // Verificar si todas las palabras del importe en letras están en el texto
            const todasLasPalabrasPresentes = palabrasImporte.every((palabra) =>
              textLower.includes(palabra),
            );

            if (todasLasPalabrasPresentes) {
              flagImporte = true;
            }
          }
        }
      }

      if (!flagCuitReceptor && !flagCuitReceptorChecked) {
        return {
          msg: `En el archivo no se encuentra el C.U.I.T ${licencia.cuit} de ${licencia.nombre} como empresa receptora.`,
          isBlocking: false,
          capturedObservationMsg: "cuitReceptor",
          flagCuitReceptorChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagFechaChecked: flagFechaChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
        };
      }
      if (!flagCuitEmisor && !flagCuitEmisorChecked) {
        return {
          msg: "El cuit del proveedor seleccionado no concuerda con el especificado en el archivo.",
          isBlocking: false,
          capturedObservationMsg: "cuitEmisor",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagFechaChecked: flagFechaChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
        };
      }
      if (!flagNroFactura && !flagNroFacturaChecked) {
        return {
          msg: "El número de comprobante ingresado no concuerda con el especificado en el archivo.",
          capturedObservationMsg: "nroFactura",
          isBlocking: true, // BLOQUEANTE
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagFechaChecked: flagFechaChecked,
        };
      }
      if (!flagFecha && !flagFechaChecked) {
        return {
          msg: "La fecha de emisión ingresada no concuerda con la especificada en el archivo.",
          isBlocking: true, // BLOQUEANTE
          capturedObservationMsg: "fecha",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
          flagFechaChecked: true,
          flagImporteChecked: flagImporteChecked,
        };
      }
      if (!flagImporte && !flagImporteChecked) {
        return {
          msg: "El importe ingresado no concuerda con el especificado en el archivo.",
          isBlocking: false,
          capturedObservationMsg: "importe",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
          flagFechaChecked: flagFechaChecked,
          flagImporteChecked: true,
        };
      } else {
        return { msg: "" };
      }
    } catch (error) {
      console.error(
        "Error durante la validación de valores del archivo:",
        error,
      );

      throw new Error(
        "Ocurrió un error al validar la información del archivo adjunto. Por favor, intente nuevamente.",
        { cause: error },
      );
    }
  };

  const handleSaveRequirement = async (
    validationObj = {
      flagCuitEmisorChecked: false,
      flagCuitReceptor: false,
      flagNroFactura: false,
      flagFecha: false,
      flagImporte: false,
    },
    remitosOverride = null,
    nroForOverride = null,
  ) => {
    setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el comprobante.

    const canBypassBlockingError = (msgObject) => {
      if (!msgObject.isBlocking) return true;

      const perms = usuario.permissionRegTdoc;
      if (!perms?.notRestrictions) return false;

      return (
        (perms.allowInvalidNroCodOri &&
          msgObject.capturedObservationMsg === "nroFactura") ||
        (perms.allowInvalidDateOfIssue &&
          msgObject.capturedObservationMsg === "fecha")
      );
    };

    const showConfirmWarning = (msg) =>
      Swal.fire({
        title: "Ops!",
        icon: "warning",
        text: msg + "Esta seguro que desea guardar el comprobante?",
        showConfirmButton: true,
        showCancelButton: true, // Habilita el botón de cancelar
        confirmButtonColor: "#ff0000",
        denyButtonColor: "#3d4d87",
        confirmButtonText: "Sí, estoy seguro",
        cancelButtonText: "No",
        allowEnterKey: true,
      });

    const showBlockingError = async (msg) => {
      await Swal.fire({
        title: "No se puede guardar",
        icon: "error",
        text: msg,
        confirmButtonText: "Aceptar",
      });
    };

    try {
      const newLista = items.filter((d) => d.artCod !== "");
      let validation = await validate(newLista);
      if (validation == "") {
        if (!skipValidation) {
          setProcessingPDF(true);

          // Paso 1: Extraer solo texto nativo (rápido, sin OCR)
          const nativeText = text && !isModifiedFile
            ? text
            : await procesarArchivo(false);

          // Paso 2: Validar con texto nativo
          const nativeMsgObject = nativeText
            ? await validateValoresArchivo(validationObj, nativeText)
            : null;

          if (nativeMsgObject && nativeMsgObject.msg === "") {
            // Texto nativo pasa todas las validaciones → guardar sin OCR
            console.log("✓ Texto nativo pasó validaciones, omitiendo OCR");
            setProcessingPDF(false);
          } else {
            // Texto nativo insuficiente o falló validación → lanzar OCR para mayor cobertura
            console.log("ℹ Texto nativo falló validación, lanzando OCR...");
            const TIMEOUT_OCR_MS = 150 * 1000;
            const textArchivo = await Promise.race([
              procesarArchivo(true),
              new Promise((resolve) =>
                setTimeout(() => resolve(null), TIMEOUT_OCR_MS),
              ),
            ]);
            setProcessingPDF(false);

            if (textArchivo === null) {
              console.warn(
                "⚠ Timeout OCR: no se pudo procesar el archivo por baja calidad de imagen.",
              );
              if (isAdminOrControl) {
                const result = await showConfirmWarning(
                  "No se pudo validar el archivo adjunto por baja calidad de imagen. ",
                );
                if (result.isConfirmed) {
                  observadaRef.current = true;
                  msgsObservadaRef.current.nroFactura =
                    "No se pudo validar el archivo por baja calidad de imagen.";
                } else {
                  setControlBotonEnviar(false);
                  return;
                }
              } else {
                await Swal.fire({
                  title: "No se pudo validar el archivo",
                  text: "No se pudo validar el archivo adjunto por baja calidad de imagen.",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
                setControlBotonEnviar(false);
                return;
              }
            }

            let msgObject =
              textArchivo !== null
                ? await validateValoresArchivo(validationObj, textArchivo)
                : { msg: "" };

            if (msgObject.msg != "") {
              if (!canBypassBlockingError(msgObject)) {
                await showBlockingError(msgObject.msg);
                setControlBotonEnviar(false);
                return;
              }
              const result = await showConfirmWarning(msgObject.msg);

              const { msg, capturedObservationMsg, ...validationValoresArchivo } =
                msgObject;

              const updateObservation = (type, isConfirmed) => {
                observadaRef.current = isConfirmed;
                const propertyName = type;
                msgsObservadaRef.current[propertyName] = isConfirmed ? msg : "";
              };

              if (result.isConfirmed) {
                updateObservation(capturedObservationMsg, true);
                await handleSaveRequirement(validationValoresArchivo);
              } else {
                updateObservation("cuitReceptor", false);
                updateObservation("cuitEmisor", false);
                updateObservation("nroFactura", false);
                updateObservation("fecha", false);
                updateObservation("importe", false);
                setControlBotonEnviar(false);
              }
              return;
            }
          }
        }

        {
          const getDatosObservacion = () => ({
            observada: observadaRef.current,
            motivoObserv: [
              msgsObservadaRef.current.cuitReceptor,
              msgsObservadaRef.current.cuitEmisor,
              msgsObservadaRef.current.nroFactura,
              msgsObservadaRef.current.fecha,
              msgsObservadaRef.current.importe,
            ]
              .filter(Boolean)
              .join(" | "),
          });

          const ocsAplParaGuardar = checkOcApl
            ? []
            : (requeriment.ocsApl?.nroFor ? requeriment.ocsApl.nroFor : []).map(
                (option) => ({ nroFor: Number(option.value), remitos: [] })
              );

          let resp;
          if (edicion === "Edicion") {
            resp = await guardarReq(
              {
                ...requeriment,
                ocsApl: ocsAplParaGuardar,
                codDim: subcuentaSelected.codDim,
                codDimDescrp: subcuentaSelected.codDimDescrp,
                subCue: subcuentaSelected.subCue,
                subCueDescrp: subcuentaSelected.subCueDescrp,
                ...getDatosObservacion(),
              },
              newLista,
              selectedFiles,
            );
            setControlBotonEnviar(false); // Habilitar el botón nuevamente
            cerrar();
          } else {
            resp = await guardarReq(
              {
                ...requeriment,
                ocsApl: ocsAplParaGuardar,
                codDim: subcuentaSelected.codDim,
                codDimDescrp: subcuentaSelected.codDimDescrp,
                subCue: subcuentaSelected.subCue,
                subCueDescrp: subcuentaSelected.subCueDescrp,
                ...getDatosObservacion(),
              },
              newLista,
              selectedFiles,
            );

            if (resp && edicion !== "Edicion") {
              setRequeriment(
                isProfileProv
                  ? {
                      ...req,
                      codOri: "",
                      importe: "",
                      nroCta: usuario.nroCta,
                      nroCtaDescrp: usuario.fullName,
                    }
                  : { ...req, codOri: "", importe: "" },
              );
              setPtoVentaComprobante("");
              setNroComprobante("");
              setSelectedFiles(files);
              setItems([estructura_producto]);
            }
            navigate("/Home");
          }
        }
      } else {
        setControlBotonEnviar(false); // Habilitar el botón nuevamente
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: validation,
          icon: "error",
        });
      }
    } catch (error) {
      await Swal.fire({
        title: "Error al guardar el comprobante",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Ocurrió un error inesperado",
        icon: "error",
      });
    } finally {
      setControlBotonEnviar(false);
    }
  };

  const eliminaFile = (aborrar) => {
    const array = Array.from(selectedFiles);
    setSelectedFiles(array.filter((data) => data.name !== aborrar.name));
  };

  const cambioColorSeleccion = () => {
    setSelectionColor(!selectionColor);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "ocsApl") {
      const numericValue = value.replace(/\D/g, "");
      setRequeriment({
        ...requeriment,
        ocsApl: {
          ...requeriment.ocsApl,
          nroFor: numericValue === "" ? null : Number(numericValue), // importante convertir a número
        },
      });
    } else {
      setRequeriment({ ...requeriment, [name]: value });
    }
  };

  const handleChangeOcApl = (selectedOptions) => {
    setRequeriment((prev) => ({
      ...prev,
      ocsApl: {
        ...prev.ocsApl,
        nroFor: selectedOptions || [],
      },
    }));
  };

  const handlerClickNotOc = (bool) => {
    // Hacer blur del input antes de procesar
    const inputOcApl = document.getElementById("inputOcApl");

    if (bool === true) {
      setRequeriment((prev) => ({
        ...prev,
        ocsApl: {
          nroFor: [],
        },
      }));
      setcheckOcApl(true);
    } else {
      setcheckOcApl(false);
      setRequeriment((prev) => ({
        ...prev,
        ocsApl: {
          nroFor: [],
        },
      }));
    }
  };

  if (loading) {
    return (
      <div
        className="container-gr-addreq"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container-gr-addreq">
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ width: "30%", marginLeft: "20px" }}>
            <SelectList
              text={"Proveedor"}
              options={proveedores.map((p) => {
                return {
                  value: `${p.nroCta}`,
                  label: `${p.nroCta} - ${p.nombre}`,
                };
              })}
              handleChange={handleChangeProveedor}
              property={"Proveedor"}
              valueAux={{
                label:
                  requeriment.nroCtaDescrp && requeriment.nroCta
                    ? `${requeriment.nroCta} - ${requeriment.nroCtaDescrp}`
                    : "Seleccione...",
                value: requeriment.nroCta || "",
              }}
              disabled={edicion === "Edicion" ? true : isProfileProv}
              emptyInputs={[]}
              styles={{
                additionalStyleDivSelectList: {
                  alignItems: "left",
                },
                fontStyleTitle: {
                  fontWeight: "bold",
                  fontSize: "22px",
                  color: "#7c7b7b",
                  marginLeft: "9px",
                },
              }}
              fontBold={true}
            />
            {requeriment.cuitProv !== "" && (
              <label className="label-cuit-prov">
                C.U.I.T: {requeriment.cuitProv}
              </label>
            )}
          </div>
          <div style={{ width: "25%" }}>
            <SelectList
              text={"Tipo de Comprobante"}
              options={tiposComprobantes.map((tC) => {
                return {
                  value: `${tC.tipo}`,
                  label: `${tC.tipo} - ${tC.descripcion}`,
                };
              })}
              handleChange={handleChangeTipoComprobante}
              property={"Tipo de Comprobante"}
              valueAux={{
                label:
                  requeriment.tDocCodFor && requeriment.tDocCodForDescrp
                    ? `${requeriment.tDocCodFor} - ${requeriment.tDocCodForDescrp}`
                    : "Seleccione...",
                value: requeriment.tDocCodFor || "",
              }}
              disabled={edicion === "Edicion" ? true : false}
              emptyInputs={[]}
              styles={{
                additionalStyleDivSelectList: {
                  alignItems: "left",
                },
                fontStyleTitle: {
                  fontWeight: "bold",
                  fontSize: "22px",
                  color: "#7c7b7b",
                  marginLeft: "9px",
                },
              }}
              fontBold={true}
            />
          </div>
          <div className="container-numero-factura">
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input
                placeholder={
                  ENTORNO.toLowerCase().includes("solimeno") ? "0000" : "00000"
                }
                name="ptoVenta"
                className="list-item-header-title-addReq"
                value={ptoVentaComprobante}
                onChange={handleChangePtoVenta}
                onBlur={handleBlurPtoVenta}
                autoFocus={true}
                style={{
                  fontWeight: "bold",
                  width: "80px",
                  textAlign: "left",
                  fontSize: "20px",
                }}
                maxLength={5}
              />
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "25px",
                  marginTop: "20px",
                }}
              >
                -
              </span>
              <input
                placeholder="00000000"
                name="nroComprobante"
                className="list-item-header-title-addReq"
                value={nroComprobante}
                onChange={handleChangeNroComprobante}
                onBlur={handleBlurNroComprobante}
                style={{
                  paddingLeft: "20px",
                  fontWeight: "bold",
                  width: "120px",
                  textAlign: "left",
                  fontSize: "20px",
                }}
                maxLength={8}
              />
            </div>
            {edicion && (
              <FontAwesomeIcon
                style={{
                  cursor: "pointer",
                  marginTop: "-50px",
                  marginLeft: "auto",
                  fontSize: "40px",
                }}
                icon={faXmark}
                onClick={() => cerrar(null)}
              />
            )}
          </div>
        </div>
        <div className="container-AddReq-item-gral">
          <div className="subContainer-AddReq-item-gral">
            <div className="container-AddReq-item-details">
              <div className="container-r-item-title-details">
                Fecha de Emisión
              </div>
              <input
                type="date"
                className="label-AddReq-fecha"
                value={moment(requeriment.dateOfIssue).format("YYYY-MM-DD")}
                onChange={(data) => handleChangeDateOfIssue(data.target.value)}
              />
            </div>
            <div className="container-flex-importe-moneda">
              <div className="container-AddReq-item-details">
                <div className="container-r-item-title-details">
                  Importe total
                </div>
                <div
                  className={`bg-white
                  ${
                    onFocus == "importe" ? "inputGroup focused" : "inputGroup"
                  }`}
                >
                  <label onClick={() => importeRef.current.focus()}>$</label>
                  <input
                    onFocus={handleFocusImporte}
                    onBlur={handleBlurImporte}
                    onChange={handleChangeImporte}
                    ref={importeRef}
                    type="text"
                    value={formattedImporte}
                    name="importe"
                    placeholder="0.00"
                    className="label-AddReq-import"
                  />
                </div>
              </div>
              <div className="container-AddReq-item-details">
                <SelectList
                  text={"Moneda"}
                  options={opcionesMoneda.map((o) => {
                    return {
                      value: `${o}`,
                      label: `${o}`,
                    };
                  })}
                  handleChange={handleChangeMoneda}
                  property={"Moneda"}
                  valueAux={{
                    label: requeriment.moneda
                      ? `${requeriment.moneda}`
                      : "Seleccione...",
                    value: requeriment.moneda || "",
                  }}
                  emptyInputs={[]}
                  styles={{
                    additionalStyleDivSelectList: {
                      alignItems: "left",
                    },
                    fontStyleTitle: {
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: "22px",
                      color: "#7c7b7b",
                      marginLeft: "9px",
                    },
                  }}
                  fontBold={true}
                />
              </div>
              <div className="container-AddReq-item-details">
                <div className="container-r-item-title-details">Cotización</div>
                <div
                  className={`inputGroup ${
                    onFocus == "cotizacion" ? "focused" : ""
                  } ${
                    requeriment.moneda == "PESOS"
                      ? "disabled-input bg-disabled"
                      : "bg-white"
                  }`}
                >
                  <label
                    className={`l ${
                      requeriment.moneda == "PESOS" ? "disabled-input" : ""
                    }`}
                    onClick={() => cotizacionRef.current.focus()}
                  >
                    $
                  </label>
                  <input
                    onFocus={handleFocusCotizacion}
                    onBlur={handleBlurCotizacion}
                    onChange={handleChangeCotizacion}
                    ref={cotizacionRef}
                    type="text"
                    value={formattedCotizacion}
                    className={`label-AddReq-import ${
                      requeriment.moneda == "PESOS" ? "disabled-input" : ""
                    }`}
                    disabled={requeriment.moneda == "PESOS"}
                    name="cotizacion"
                    placeholder="0.00"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container-AddReq-item-details-text">
            <div className="container-r-item-title-details">
              Texto Adicional
            </div>
            <div className="container-input-texto">
              <div className="r-list-item-details-data-v">
                <textarea
                  placeholder="Ingrese texto adicional"
                  className="r-item-text-input"
                  style={{ fontWeight: 600 }}
                  value={requeriment.observ}
                  onChange={(data) => handleChangObservation(data.target.value)}
                ></textarea>
              </div>
            </div>
          </div>

          {globalSettings &&
            globalSettings.requiredSubcuenta == true &&
            globalSettings.codDim !== "" && (
              <div
                style={{ width: "30%", marginLeft: "20px", marginTop: "30px" }}
              >
                <SelectList
                  text={"Subcuenta"}
                  options={subcuentas.map((s) => {
                    return {
                      value: `${s.subCue}`,
                      label: `${s.subCue} - ${s.subCueDescrp}`,
                    };
                  })}
                  handleChange={handleChangeSubcuenta}
                  property={"Subcuenta"}
                  valueAux={{
                    label: subcuentaSelected.subCue
                      ? `${subcuentaSelected.subCue} - ${subcuentaSelected.subCueDescrp}`
                      : "Seleccione...",
                    value: subcuentaSelected.subCue || "",
                  }}
                  emptyInputs={[]}
                  styles={{
                    additionalStyleDivSelectList: {
                      alignItems: "left",
                    },
                    fontStyleTitle: {
                      fontWeight: "bold",
                      fontSize: "22px",
                      color: "#7c7b7b",
                      marginLeft: "9px",
                    },
                  }}
                  fontBold={true}
                />
              </div>
            )}

          <div className="getOCPDiv">
            <label className="container-r-item-title-details">
              Órdenes de Compra
            </label>
            <div className="inputs-oc-y-checkbox">
              <div className="inputs-codori">
                <DropDownPicker
                  isCreatable
                  numberOnly
                  isDisabled={checkOcApl}
                  placeholder={checkOcApl ? "" : "Escriba un número y presione Enter"}
                  value={requeriment.ocsApl?.nroFor ? requeriment.ocsApl.nroFor : []}
                  onChange={handleChangeOcApl}
                  containerStyle={{ minWidth: "400px", width: "auto" }}
                />
              </div>
              <div className="not-oc-item-inline">
                <input
                  type="checkbox"
                  checked={checkOcApl}
                  onChange={(e) => handlerClickNotOc(e.target.checked)}
                />
                <label className="not-oc-item-label">
                  No tengo Órdenes de Compra
                </label>
              </div>
            </div>
          </div>
        </div>
        {/*       <div className="container-AddReq-item-details-items">
        <div className="container-r-item-title-details">
          Items: {items.length === 0 ? 0 : items.length - 1}
        </div>
        <div className="container-items-products-rq-gral">
          {items.length > 0 &&
            items.map((c, index) => {
              return (
                <NewProductItm
                  data={c}
                  index={index}
                  key={c.usr_id}
                  productsList={productList}
                  ocpsRecuperadas={ocpsRecuperadas}
                  agregaItem={(data) => handleagregaItem(data)}
                  modificaItm={(data, indice) => handleChangeItm(data, indice)}
                  borraItem={() => handleDeleteConcept(c, index)}
                />
              );
            })}
        </div>
      </div> */}

        <div>
          {isAdminOrControl && (
            <div className="skip-validation">
              <input
                type="checkbox"
                checked={skipValidation}
                onChange={(e) => setSkipValidation(e.target.checked)}
              />
              <label className="label-skip-validation">
                Guardar sin validar adjunto
              </label>
            </div>
          )}

          {/* <div className='container-button-rq-save-new2'><button className='button-rq-save-new2' onClick={}>Agregar Archivo  </button></div> */}
          <div className="container-button-rq-save-new2">
            <div
              className={`${
                selectionColor
                  ? "button-rq-save-new2-selected"
                  : selectedFiles.length >= 1
                    ? "disabled-file"
                    : "button-rq-save-new2"
              }`}
            >
              <div
                className={`file-select ${
                  selectedFiles.length >= 1 ? "disabled-cursor" : ""
                }`}
                id="src-file1"
              >
                <input
                  onFocus={cambioColorSeleccion}
                  type="file"
                  name="src-file1"
                  aria-label="Agregar Archivo .pdf .jpg .jpeg"
                  onChange={handleFileInputChange}
                  disabled={selectedFiles.length >= 1}
                  accept=".pdf, .jpg, .jpeg"
                />
              </div>
            </div>
          </div>

          <div className="container-new-rq-files">
            <ul className="container-new-rq-files-details">
              {selectedFiles.map((file) => (
                <li key={file.name}>
                  {file.name}
                  <FontAwesomeIcon
                    onClick={() => eliminaFile(file)}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "20px",
                    }}
                    icon={faXmark}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="container-button-rq-save-new">
          <button
            className={`button-rq-save-new ${
              controlBotonEnviar ? "disabled" : ""
            }`}
            disabled={controlBotonEnviar}
            onClick={handleSaveRequirement}
          >
            Finalizar
          </button>
        </div>
        {processingPDF && (
          <div className="modalLoading">
            <div className="modalLoadingContainer">
              <h4>Aguarde mientras se validan los datos</h4>
              <FontAwesomeIcon
                className="loadingIcon"
                icon={faSpinner}
                color="black"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FormReq;
